/**
 * State used in rendering Toaster
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
